import { useTranslation } from "react-i18next";
import { Lead } from "../../models/Lead";
import { Modal } from "../Modal";
import { PaperAirplaneIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        leadExists?: Lead;
        phoneExists?: string;
    };
    onClose: () => void;
    onContinueCreate: () => void;
}

export const LeadExistsConfirmationModal: React.FC<Props> = ({
    info,
    onClose,
    onContinueCreate
}) => {

    const { t } = useTranslation();

    return(
        <Modal
            isOpen={info.show}
            label={t("LEAD_ALREADY_EXISTS")}
            onClose={onClose}
            hideCancelButton={true}
            thirdButton={{
                label: t("CONTINUE_ANYWAY"),
                icon: <PaperAirplaneIcon />,
                onClick: onContinueCreate,
            }}
            saveButton={{
                label: t("CLOSE"),
                icon: <XMarkIcon />,
                onClick: onClose,
            }}
        >
            <div className="w-full grid justify-items-center">
                <div className="text-center font-medium mx-2">
                    {`${t('A_LEAD_WITH_PHONE')}`} {`${info.phoneExists}`} {`${t('LEAD_IS_BEING_CONTACTED_BY', {agentName: info.leadExists?.agent_name})}`}
                </div>
                <div className="text-center font-medium mx-2 my-5">
                    {t('CONTINUE_CREATING_LEAD')}
                </div>
            </div>
        </Modal>
    )
}